export default __webpack_public_path__ + "static/media/snowstorm.7edab3a3.png";